import { render, staticRenderFns } from "./WpInstallDialog.vue?vue&type=template&id=69661dde&"
import script from "./WpInstallDialog.vue?vue&type=script&lang=ts&"
export * from "./WpInstallDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports